import i18nData from "./editor/i18nData";
import i18nDataAlex from "./alex/i18nData";
import i18nDataEmotionhack from "./emotionhack/i18nData";
import i18nDataCoach from "./coach/i18nData";
import i18nDataOrgDashboard from "./org-dashboard/i18nData";

// en, de, fr, pt
export default {
  en: {
    editor: i18nData.en,
    alex: i18nDataAlex.en,
    emotionhack: i18nDataEmotionhack.en,
    coach: i18nDataCoach.en,
    orgDashboard: i18nDataOrgDashboard.en,
  },
  de: {
    editor: i18nData.de,
    alex: i18nDataAlex.de,
    emotionhack: i18nDataEmotionhack.de,
    coach: i18nDataCoach.en,
    orgDashboard: i18nDataOrgDashboard.de,
  },
  fr: {
    editor: i18nData.fr,
    alex: i18nDataAlex.fr,
    emotionhack: i18nDataEmotionhack.fr,
    coach: i18nDataCoach.en,
    orgDashboard: i18nDataOrgDashboard.fr,
  },
  pt: {
    editor: i18nData.pt,
    alex: i18nDataAlex.pt,
    emotionhack: i18nDataEmotionhack.en,
    coach: i18nDataCoach.en,
    orgDashboard: i18nDataOrgDashboard.pt,
  },
  es: {
    // Spanish
    editor: i18nData.es,
    alex: i18nDataAlex.es,
    emotionhack: i18nDataEmotionhack.es,
    coach: i18nDataCoach.es,
    orgDashboard: i18nDataOrgDashboard.es,
  },
  nl: {
    // Dutch
    editor: i18nData.nl,
    alex: i18nDataAlex.nl,
    emotionhack: i18nDataEmotionhack.nl,
    coach: i18nDataCoach.en,
    orgDashboard: i18nDataOrgDashboard.nl,
  },
  it: {
    // Italian
    editor: i18nData.it,
    alex: i18nDataAlex.it,
    emotionhack: i18nDataEmotionhack.it,
    coach: i18nDataCoach.en,
    orgDashboard: i18nDataOrgDashboard.it,
  },
};
